@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.title {
  text-align: center;
  @include t.text(20px, 30px, 600);
  color: v.$palette-gray-900;
  margin-bottom: 16px;
}